import get from 'lodash/get';
import { createSelector } from 'reselect';
import { ProductType } from '../../enums';

import { getEntities } from '../../global-selectors';
import { wrappOnlyAddOns } from '../../utils/products';


export const selectShoppingCartConfig = createSelector(
  getEntities,
  entities => get(entities, 'shoppingCart', [])
);

export const getProductsToBuy = createSelector(
  selectShoppingCartConfig,
  shoppingCart => get(shoppingCart, 'productsToBuy', [])
);

export const selectExchangeOrder = createSelector(
  selectShoppingCartConfig,
  shoppingCart => get(shoppingCart, 'exchange')
);

export const selectAddOnsToShow = createSelector(
  selectShoppingCartConfig,
  shoppingCart => get(shoppingCart, 'addOnsToShow')
);

export const getSelectedPlan = createSelector(
  getProductsToBuy,
  products => products?.find(product => product.productType === ProductType.PLAN)
);

export const getSelectedAddOns = createSelector(
  getProductsToBuy,
  products => wrappOnlyAddOns(products)
);
export const getSelectedPPV = createSelector(
  getProductsToBuy,
  products => products?.find(product => product.productType === ProductType.ADD_ON)
);

